"use client";
import classes from "./Carousel.module.css";
import FullScreenModal from "../../../../../../components/modals/product-related/FullScreenModal";
import { Maximize2 } from "react-feather";
import { useEffect, useState } from "react";

const FullScreenButton = ({ listing, consignPanel }) => {
  const [isFullscreen, setFullscreen] = useState(null);

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const imageElement = document.getElementById("carousel-image");

    if (!imageElement) return;

    // Create a MutationObserver to listen for changes to the `src` attribute
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === "currentindex") {
          const currentVal = imageElement.getAttribute("currentindex");
          setCurrent(currentVal ? Number(currentVal) : 0);
        }
      }
    });

    // Start observing changes to the `src` attribute
    observer.observe(imageElement, { attributes: true });

    // Cleanup observer when component unmounts
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {!consignPanel && (
        <>
          <div
            className={classes.fullButton}
            onClick={() => setFullscreen(listing.images[current])}
          >
            <Maximize2 className={classes.fullButtonWhite} />
          </div>
          <FullScreenModal
            listing={listing}
            isFullscreen={isFullscreen}
            setFullscreen={setFullscreen}
          />
        </>
      )}
      <div className={classes.dotsContainer}>
        {listing.images.map((dot, idx) => (
          <div
            key={idx}
            className={
              listing.images[current] === dot ? classes.dotActive : classes.dot
            }
          />
        ))}
      </div>
    </>
  );
};

export default FullScreenButton;
